import React from "react";
import { Link } from "react-router-dom";

import { ButtonGroupWrapper } from "@jsluna/button";
import { Notification } from "@jsainsburyplc/id-ui-common";

import { getForgottenPasswordLink } from "utils/urls";
import missionConfig from "missionConfig";

const { showRequestPasswordResetLink } = missionConfig;

const TokenExpired = () => (
  <>
    <div className="c-hero c-hero--center">
      <h1>Reset password link expired</h1>
    </div>
    <div className="ln-u-soft">
      <Notification>
        This password reset link has expired or is invalid. <br />
        Please request a new link.
      </Notification>
      {showRequestPasswordResetLink && (
        <ButtonGroupWrapper className="ln-u-text-align-center">
          <Link
            to={getForgottenPasswordLink()}
            className="ln-c-button ln-c-button--filled"
          >
            Request password reset link
          </Link>
        </ButtonGroupWrapper>
      )}
    </div>
  </>
);

export default TokenExpired;
